import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useAuth } from '../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    [theme.breakpoints.up('sm')]: {
        width: '450px',
    },
}));

export default function SignUpCard() {
    const [emailError, setEmailError] = React.useState('');
    const [passwordError, setPasswordError] = React.useState('');
    const [confirmError, setConfirmError] = React.useState('');
    const [usernameError, setUsernameError] = React.useState('');
    const [nameError, setnameError] = React.useState('');

    const [formError, setFormError] = React.useState('');
    const location = useLocation();

    const role = location.state?.role ?? "brand";

    const { Register } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setFormError('');

        const data = new FormData(event.currentTarget);
        const name = data.get('name');
        const username = data.get('username');
        const email = data.get('email');
        const password = data.get('password');
        const confirmPassword = data.get('confirmPassword');

        const isValid = validateInputs(name, username, email, password, confirmPassword);
        if (!isValid) return;

        const success = await Register(name, username, email, password, confirmPassword, role);
        if (success === true) {
            navigate('/sign-in', { replace: true });
        } else {
            setFormError(success.message);
        }
    };

    const validateInputs = (name, username, email, password, confirmPassword) => {
        let isValid = true;

        if (!name) {
            setnameError('name can not be empty');
            isValid = false;
        } else {
            setnameError('');
        }
        if (!username || username.length < 3) {
            setUsernameError('Username must be at least 3 characters.');
            isValid = false;
        } else {
            setUsernameError('');
        }

        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            setEmailError('Please enter a valid email address.');
            isValid = false;
        } else {
            setEmailError('');
        }

        if (!password || password.length < 6) {
            setPasswordError('Password must be at least 6 characters.');
            isValid = false;
        } else {
            setPasswordError('');
        }

        if (password !== confirmPassword) {
            setConfirmError('Passwords do not match.');
            isValid = false;
        } else {
            setConfirmError('');
        }

        return isValid;
    };

    return (
        <Card variant="outlined">
            <Typography variant="h4" sx={{ textAlign: 'center' }}>
                Sign Up
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <FormControl>
                    <FormLabel>Name</FormLabel>
                    <TextField
                        id="name"
                        name="name"
                        placeholder="Enter name"
                        required
                        fullWidth
                        error={!!nameError}
                        helperText={nameError}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Username</FormLabel>
                    <TextField
                        id="username"
                        name="username"
                        placeholder="Enter username"
                        required
                        fullWidth
                        error={!!usernameError}
                        helperText={usernameError}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Email</FormLabel>
                    <TextField
                        id="email"
                        name="email"
                        type="email"
                        placeholder="your@email.com"
                        required
                        fullWidth
                        error={!!emailError}
                        helperText={emailError}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Password</FormLabel>
                    <TextField
                        id="password"
                        name="password"
                        type="password"
                        placeholder="••••••"
                        required
                        fullWidth
                        error={!!passwordError}
                        helperText={passwordError}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Confirm Password</FormLabel>
                    <TextField
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        placeholder="••••••"
                        required
                        fullWidth
                        error={!!confirmError}
                        helperText={confirmError}
                    />
                </FormControl>



                {formError && (
                    <Typography color="error" variant="body2">
                        {formError}
                    </Typography>
                )}

                <Button type="submit" fullWidth variant="contained">
                    Sign Up
                </Button>
            </Box>
        </Card>
    );
}
